<template>
  <div class="giving-container">
    <!-- Main Content -->
    <div class="container-fluid" style="height: 100vh">
      <div class="row align-items-center">
        <div
          class="col-md-6 col-12 donation-bg d-none d-md-block"
          style="height: 100vh"
        >
          <!-- Title Section -->
          <div
            class="col-md-12 d-flex justify-content-center align-items-center"
            style="height: 80vh"
          >
            <div class="row mb-5 justify-content-center">
              <div class="col-md-12 text-center">
                <div class="d-flex justify-content-center">
                  <div class="church-info flex-column">
                    <img
                      v-if="formResponse.churchLogo"
                      :src="formResponse.churchLogo"
                      alt="Church Logo"
                      class="church-logo"
                    />
                    <img
                      v-else
                      src="../../../assets/churchplusblueLogo.png"
                      alt="Church Logo"
                      class="church-logo"
                    />
                    <div class="church-details">
                      <span class="church-name">{{
                        formResponse.churchName || ""
                      }}</span>
                    </div>
                  </div>
                </div>

                <div class="subtitle mb-5">
                  Make Donations online securely with ChurchPlus
                </div>
                <div class="col-md-12 d-flex justify-content-center">
                  <img
                    style="height: 200px; width: 300px"
                    src="../../../assets/undraw_global.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12 mt-5" style="height: 20vh">
            <div class="row justify-content-center">
              <div class="col-md-7 col-11 bg-white border-radius-50 pb-2 pt-3">
                <div class="s-12 fw-400 text-dak text-center">
                  <el-icon class="text-dak"><Lock /></el-icon> Secured Payment
                  Gateways
                </div>
                <div class="col-md-12 px-0">
                  <div class="payment-methods mt-1">
                    <div class="payment-logos">
                      <img
                        src="../../../assets/stripe.png"
                        alt="Paystack"
                        class="payment-logo"
                      />
                      <img
                        src="../../../assets/visasmall.png"
                        alt="Mastercard"
                        style="height: 13px !important"
                        class="payment-logo"
                      />
                      <img
                        src="../../../assets/3MasterCard500.png"
                        alt="Mastercard"
                        class="payment-logo"
                      />

                      <img
                        src="../../../assets/4PaystackLogo.png"
                        alt="Visa"
                        class="payment-logo"
                      />
                      <img
                        src="../../../assets/flutterwavelogo.png"
                        alt="Paystack"
                        class="payment-logo"
                        style="height: 40px !important"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="col-md-6 col-12"
          style="max-height: 100vh; overflow-y: auto"
        >
          <!-- <transition name="move" mode="out-in"> -->
          <div
            class="col-md-12 px-0"
            v-loading="paymentStatusLoading"
            element-loading-text="Please wait while we confirm your payment ..."
            key="form"
          >
            <div
              class="row donation-bg-mobile justify-content-center d-flex d-md-none"
            >
              <div class="col-md-12 d-flex justify-content-end mt-4">
                <div
                  @click.prevent="signOut"
                  class="sign-out-link fw-400 cursor-pointer text-dak ml-2"
                >
                  Logout
                </div>
              </div>
              <div class="col-md-12 text-center">
                <div class="d-flex justify-content-center">
                  <div class="church-info flex-column">
                    <img
                      v-if="formResponse.churchLogo"
                      :src="formResponse.churchLogo"
                      alt="Church Logo"
                      class="church-logo-mobile"
                    />
                    <div class="text-dak s-20 font-weight-600">
                      <span>{{ formResponse.churchName || "" }}</span>
                    </div>
                  </div>
                </div>

                <div class="s-14 text-dak fw-300 mb-4">
                  Make Donations online securely with ChurchPlus
                </div>
              </div>
            </div>
            <div
              class="col-md-11 px-0 d-md-flex d-none justify-content-end mt-5"
            >
              <div class="d-flex align-items-center">
                <div class="church-info">
                  <img
                    v-if="formResponse.churchLogo"
                    :src="formResponse.churchLogo"
                    alt="Church Logo"
                    class="church-logo-small"
                  />
                </div>
                <div
                  @click.prevent="signOut"
                  class="sign-out-link fw-400 cursor-pointer text-dak ml-2"
                >
                  Logout
                </div>
              </div>
            </div>
            <div class="row justify-content-center mt-5">
              <div class="col-md-9 col-12">
                <!-- Giving Form -->
                <div class="row">
                  <div class="col-12">
                    <div class="giving-form">
                      <el-form
                        ref="givingFormRef"
                        :model="givingForm"
                        :rules="formRules"
                        label-position="top"
                        @submit.prevent="handleGiving"
                      >
                        <!-- Giving Purpose -->
                        <div class="form-group mb-4">
                          <div class="form-label">Giving Purpose</div>
                          <el-select
                            v-model="givingForm.purposeId"
                            placeholder="Select Purpose"
                            class="w-100"
                            size="large"
                            @change="setSelectedContributionType"
                          >
                            <el-option
                              v-for="purpose in purposeList"
                              :key="purpose.financialContribution.id"
                              :label="purpose.financialContribution.name"
                              :value="purpose.financialContribution.id"
                            />
                          </el-select>
                        </div>

                        <!-- Amount -->
                        <div class="form-group mb-4">
                          <div class="form-label">Amount</div>
                          <div class="amount-input-group">
                            <el-select
                              v-model="givingForm.currency"
                              class="currency-select mr-2"
                              @change="setSelectedCurrency"
                              size="large"
                            >
                              <el-option
                                v-for="currency in supportedCurrencies"
                                :key="currency.value"
                                :label="currency.value"
                                :value="currency.value"
                              />
                            </el-select>
                            <el-input
                              v-model="givingForm.amount"
                              type="number"
                              placeholder="0.00"
                              size="large"
                              class="amount-input"
                              min="0"
                              step="0.01"
                            />
                          </div>
                        </div>

                        <!-- Give as Anonymous -->
                        <div class="form-group mb-4">
                          <el-checkbox
                            v-model="givingForm.isAnonymous"
                            size="large"
                            class="anonymous-checkbox"
                          >
                            <span class="text-black fw-400"
                              >Give as Anonymous</span
                            >
                          </el-checkbox>
                        </div>

                        <!-- Giver's Information -->
                        <div
                          class="form-group dash-border mb-5"
                          v-if="!givingForm.isAnonymous"
                        >
                          <h6 class="section-title text-black fw-400">
                            Giver's Information
                          </h6>

                          <!-- Name -->
                          <div class="mb-3">
                            <div class="form-label fw-500">Name</div>
                            <el-input
                              v-model="givingForm.name"
                              placeholder="Name"
                              size="large"
                              class="w-100"
                            />
                          </div>

                          <!-- Email and Phone -->
                          <div class="row">
                            <div class="col-md-6 mb-3">
                              <div class="form-label fw-500">Email</div>
                              <el-input
                                v-model="givingForm.email"
                                type="email"
                                size="large"
                                placeholder="Email address"
                                class="w-100"
                              />
                            </div>
                            <div class="col-md-6 mb-3">
                              <div class="form-label fw-500">Phone number</div>
                              <el-input
                                v-model="givingForm.phone"
                                placeholder="+234852232"
                                size="large"
                                class="w-100"
                              />
                            </div>
                          </div>
                        </div>

                        <!-- Given Frequency -->
                        <div class="row">
                          <div class="col-md-12 mb-3">
                            <hr class="w-100" />
                          </div>
                        </div>
                        <div class="form-group mb-4">
                          <h6 class="section-title text-dak">
                            Given frequency
                          </h6>
                          <el-radio-group
                            v-model="givingForm.frequency"
                            size="large"
                            class="frequency-group mb-3"
                          >
                            <div class="d-flex">
                              <el-radio
                                label="one-time"
                                class="frequency-radio"
                              >
                                One time
                              </el-radio>
                              <el-radio
                                label="recurring"
                                class="frequency-radio"
                              >
                                Recurring Donation
                              </el-radio>
                            </div>
                          </el-radio-group>

                          <!-- Recurring Payment Options -->
                          <div
                            v-if="givingForm.frequency === 'recurring'"
                            class="recurring-options col-md-12"
                          >
                            <div class="row recurring-options">
                              <!-- Frequency Selection -->
                              <div
                                class="recurring-frequency col-md-7 col-12 mb-3 py-2 border-radius-8"
                                style="background-color: #f3fcff"
                              >
                                <el-radio-group
                                  v-model="givingForm.recurringFrequency"
                                  size="large"
                                  class="recurring-freq-group"
                                >
                                  <el-radio
                                    label="weekly"
                                    class="recurring-freq-radio text-dak fw-500"
                                  >
                                    Weekly
                                  </el-radio>
                                  <el-radio
                                    label="monthly"
                                    class="recurring-freq-radio text-dak fw-500"
                                  >
                                    Monthly
                                  </el-radio>
                                  <el-radio
                                    label="yearly"
                                    class="recurring-freq-radio text-dak fw-500"
                                  >
                                    Yearly
                                  </el-radio>
                                </el-radio-group>
                              </div>

                              <!-- Day Selection -->
                              <div
                                class="day-selection col-md-4 col-12 mb-3 border-radius-8 py-2"
                                v-if="givingForm.recurringFrequency"
                                style="background-color: #f3fcff"
                              >
                                <el-dropdown
                                  trigger="click"
                                  class="el-dropdown border-0 w-100 py-2 d-flex justify-content-end"
                                >
                                  <span class="el-dropdown-link w-100">
                                    <div
                                      class="d-flex justify-content-between primary--text w-100"
                                      size="large"
                                    >
                                      <span class="text-dak"
                                        >Set day
                                        <span class="text-dak fw-500">
                                          {{
                                            availableDays.find(
                                              (day) =>
                                                day.value ===
                                                givingForm.selectedDay
                                            )?.label || ""
                                          }}
                                        </span>
                                      </span>
                                      <div class="">
                                        <el-icon
                                          style="color: #1b809c"
                                          :size="17"
                                          ><CaretBottom
                                        /></el-icon>
                                      </div>
                                    </div>
                                  </span>
                                  <template #dropdown>
                                    <el-dropdown-menu>
                                      <el-dropdown-item
                                        v-for="(day, index) in availableDays"
                                        :key="index"
                                      >
                                        <div
                                          @click="setDays(day)"
                                          class="w-100"
                                        >
                                          {{ day.label }}
                                        </div>
                                      </el-dropdown-item>
                                    </el-dropdown-menu>
                                  </template>
                                </el-dropdown>
                              </div>

                              <!-- Recurring Charge Info -->
                              <p
                                class="recurring-charge-info s-14 fw-300 text-dak"
                              >
                                You'll be charged
                                {{
                                  formatCurrency(
                                    givingForm.amount,
                                    givingForm.currency
                                  )
                                }}
                                every {{ givingForm.recurringFrequency }} on
                                this same day.
                              </p>
                            </div>
                          </div>
                        </div>

                        <!-- Charge Information -->
                        <div
                          class="form-group mb-5"
                          v-if="givingForm.frequency === 'one-time'"
                        >
                          <p class="charge-info">
                            You'll be charged
                            {{
                              formatCurrency(
                                givingForm.amount,
                                givingForm.currency
                              )
                            }}.
                            {{
                              givingForm.frequency === "one-time"
                                ? "One time."
                                : "''."
                            }}
                          </p>
                        </div>

                        <!-- Give Now Button -->
                        <div class="form-group mb-2">
                          <el-button
                            round
                            :color="primarycolor"
                            size="large"
                            class="text-white w-100 py-4"
                            :loading="isProcessing"
                            @click="handleGiving"
                          >
                            {{ isProcessing ? "Processing..." : "Give now" }}
                          </el-button>
                        </div>
                      </el-form>
                    </div>
                  </div>
                </div>

                <!-- Footer -->
                <div class="row d-md-none">
                  <div class="col-md-12 px-0">
                    <div class="payment-methods mt-1">
                      <div class="payment-logos">
                        <img
                          src="../../../assets/stripe.png"
                          alt="Paystack"
                          class="payment-logo"
                        />
                        <img
                          src="../../../assets/visasmall.png"
                          alt="Mastercard"
                          style="height: 13px !important"
                          class="payment-logo"
                        />
                        <img
                          src="../../../assets/3MasterCard500.png"
                          alt="Mastercard"
                          class="payment-logo"
                        />

                        <img
                          src="../../../assets/4PaystackLogo.png"
                          alt="Visa"
                          class="payment-logo"
                        />
                        <img
                          src="../../../assets/flutterwavelogo.png"
                          alt="Paystack"
                          class="payment-logo"
                          style="height: 40px !important"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div class="row">
                <div class="col-12">
                  <div class="footer-section">
                    <p
                      class="powered-by d-flex align-items-center justify-content-end"
                    >
                      <span class="fw-400">Powered by</span>
                      <img
                        src="../../../assets/churchplusblueLogo.png"
                        alt="ChurchPlus"
                        class="logo"
                      />
                    </p>
                  </div>
                </div>
              </div> -->
              </div>
            </div>
            <div
              class="col-md-11 px-0 d-md-flex d-none justify-content-end mt-5"
            >
              <div class="footer-section">
                <p
                  class="powered-by d-flex align-items-end justify-content-end"
                >
                  <span class="fw-400 mr-2">Powered by</span>
                  <img
                    src="../../../assets/churchplusblueLogo.png"
                    alt="ChurchPlus"
                    class="logo"
                  />
                </p>
              </div>
            </div>
          </div>
          <!-- <div
              class="col-md-12 mx-auto form-area shadow pt-5 mb-5 bg-white rounded MIDDLE"
              v-else
              key="success"
            >
              <div class="row">
                <div class="col-2 offset-5">
                  <img src="../../../assets/smile.jpg" class="w-100" />
                </div>
                <div class="col-12 stylish-text primary-text text-center">
                  Thank You
                </div>
                <div
                  class="col-12 font-weight-700 text-center p-5 mt-4 primary-bg text-white success-card"
                >
                  Your transaction has been successful. God Bless You!
                </div>
              </div>
            </div> -->
          <!-- </transition> -->
        </div>
      </div>
    </div>

    <!-- Success Modal -->
    <el-dialog
      v-model="showSuccessModal"
      title=""
      width="400px"
      :close-on-click-modal="false"
      class="success-modal"
    >
      <div class="success-content text-center">
        <div class="success-icon mb-3">
          <i class="fas fa-check-circle"></i>
        </div>
        <h3 class="success-title">Thank You!</h3>
        <p class="success-message">
          Your donation has been processed successfully. God bless you!
        </p>
        <el-button type="primary" @click="resetForm" class="mt-3">
          Make Another Donation
        </el-button>
      </div>
    </el-dialog>

    <el-dialog
      class=""
      style="border-radius: 25px"
      v-model="showPaymentGatewayOptions"
      title=""
      :show-close="false"
      :width="mdAndUp || lgAndUp || xlAndUp ? `45%` : `90%`"
    >
      <div class="row justify-content-center">
        <div class="col-md-12 d-flex justify-content-end">
          <el-button link @click="closePaymentModal">
            <span aria-hidden="true" ref="close">&times;</span>
          </el-button>
        </div>
        <div
          class="col-md-10 mt-4 h-100 bg-white mb-5"
          v-if="showPaymentGatewayOptions"
        >
          <div class="row justify-content-center align-items-center">
            <div class="col-md-12 d-flex justify-content-center">
              <div class="col-md-12">
                <PaymentGatewayDialog
                  :formData="formResponse"
                  :donation="donationObject"
                  :name="name"
                  :close="close"
                  :amount="givingForm.amount"
                  :converted="computeAmount"
                  :email="email"
                  @payment-successful="successfulPayment"
                  :currency="defaultCurrency.shortCode"
                  @selected-gateway="gatewaySelected"
                  @transaction-reference="setTransactionReference"
                  @paystack-amount="setPaystackAmount"
                  :callPayment="callPayment"
                  @resetcallpaymentprops="resetCallPayment"
                  :initializePaymentResponse="initializePaymentResponse"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-drawer v-model="checkoutDrawer" :show-close="false" size="100%">
      <div>
        <div class="d-flex justify-content-end">
          <el-icon
            :size="30"
            class="c-pointer"
            color="red"
            @click="checkoutDrawer = false"
          >
            <CircleClose />
          </el-icon>
        </div>
        <iframe
          sandbox="allow-downloads allow-scripts allow-same-origin"
          :src="checkoutURL"
          width="100%"
          height="800"
          frameborder="0"
        ></iframe>
      </div>
    </el-drawer>
    <el-dialog
      v-model="paymentResponseDialog"
      title=""
      :width="mdAndUp || lgAndUp || xlAndUp ? `50%` : xsOnly ? `90%` : `70%`"
      align-center
      class="QRCodeDialog p-4"
    >
      <PaymentStatusDialog
        :paymentStatusMessage="paymentStatusMessage"
        @closestatusdialog="paymentResponseDialog = false"
      />
    </el-dialog>

    <el-dialog
      class="border-radius-20"
      v-model="paymentFailed"
      align-center
      title=""
      :width="mdAndUp || lgAndUp || xlAndUp ? `35%` : xsOnly ? `90%` : `70%`"
    >
      <div class="row justify-content-center">
        <div class="col-md-10 mt-4 bg-white mb-5">
          <div class="row justify-content-center align-items-center">
            <div class="col-md-8 d-flex justify-content-center">
              <div class="col-4">
                <img
                  class="w-100"
                  src="../../../assets/mobileonboarding/sub-failed.png"
                  alt=""
                />
              </div>
            </div>
            <div class="col-md-12 d-flex justify-content-center">
              <div class="col-md-10 col-12 px-0">
                <div
                  class="text-head font-weight-bold col-md-12 px-0 h2 text-center"
                  style="color: #d21615"
                >
                  Payment failed!
                </div>
              </div>
            </div>
            <div class="col-md-10 d-flex my-5 justify-content-center">
              <div class="col-md-8">
                <el-button
                  @click="tryAgain"
                  :color="primarycolor"
                  size="large"
                  class="w-100"
                  round
                  >Try again</el-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      class="border-radius-20"
      v-model="paymentDone"
      align-center
      title=""
      :width="mdAndUp || lgAndUp || xlAndUp ? `35%` : xsOnly ? `90%` : `70%`"
    >
      <div class="row justify-content-center">
        <div class="col-md-10 mt-3 bg-white mb-3" v-if="paymentSuccessful">
          <div class="row justify-content-center align-items-center">
            <div class="col-md-10 col-12 d-flex justify-content-center">
              <div class="col-6">
                <img
                  class="w-100"
                  src="../../../assets/mobileonboarding/sub-successful.gif"
                  alt=""
                />
              </div>
            </div>
            <div class="col-md-12 d-flex justify-content-center">
              <div class="col-md-10 col-12 px-0">
                <div
                  class="text-head font-weight-bold col-md-12 px-0 h2 text-center"
                  style="color: #78b348"
                >
                  Your Payment is Successful!
                </div>
              </div>
            </div>
            <div class="col-md-10 d-flex my-5 justify-content-center">
              <div class="col-md-8">
                <el-button
                  @click="resetForm"
                  :color="primarycolor"
                  size="large"
                  class="w-100"
                  round
                  >Done
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, reactive, inject, computed, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { ElNotification, ElLoading } from "element-plus";
import axios from "@/gateway/backendapi";
import deviceBreakpoint from "../../../mixins/deviceBreakpoint";
import supportedCurrencies from "@/services/user/flutterwaveSupportedCurrency";
import finish from "../../../services/progressbar/progress";
import PaymentGatewayDialog from "../../../components/paymentoption/PaymentGatewayDialog.vue";
import { paystackTransactionStatusEnum } from "../../../services/constant";
import PaymentStatusDialog from "../../../components/payment/PaymentStatusDialog.vue";
import { ConfirmPaystackTransaction } from "../../../services/settings/integrations";

// Router setup
const router = useRouter();
const route = useRoute();

// Form reference
const givingFormRef = ref();
const primarycolor = inject("primarycolor");
const showPaymentGatewayOptions = ref(false);
const initializePaymentResponse = ref({});
// Reactive data
const { mdAndUp, lgAndUp, xlAndUp, xsOnly } = deviceBreakpoint();
const isProcessing = ref(false);
const paymentStatusMessage = ref("");
const showSuccessModal = ref(false);
const paymentFailed = ref(false);
const paymentDone = ref(false);
const paymentSuccessful = ref(false);
const paymentUrl = ref("");
const name = ref("");
const phone = ref("");
const amount = ref("");
const callPayment = ref(false);
const email = ref("anonymous@churchplus.co");
const formResponse = ref({});
const purposeList = ref([]);
const currencyList = ref([]);
const selectedContributionType = ref({});
const defaultCurrency = ref({});
const close = ref("");
const selectedGateway = ref("");
const checkoutDrawer = ref(false);
const checkoutURL = ref("");
const paymentResponseDialog = ref(false);
const paymentStatusLoading = ref(false);

const givingForm = reactive({
  purposeId: "",
  currency: "NGN",
  amount: "",
  isAnonymous: true,
  name: "",
  email: "",
  phone: "",
  frequency: "one-time",
});
const successfulPayment = (payload) => {
  console.log("payment successful", payload);
  paymentSuccessful.value = payload;
  if (paymentSuccessful.value) {
    paymentDone.value = true;
  } else {
    paymentFailed.value = false;
  }
};
const closePaymentModal = () => {
  showPaymentGatewayOptions.value = false;
};

const tryAgain = () => {
  paymentFailed.value = false;
  showPaymentGatewayOptions.value = true;
};

const resetForm = () => {
  givingForm.purposeId = "";
  givingForm.currency = "NGN";
  givingForm.amount = "";
  givingForm.isAnonymous = true;
  givingForm.name = "";
  givingForm.email = "";
  givingForm.phone = "";
  givingForm.frequency = "one-time";
  givingForm.recurringFrequency = "";
  givingForm.selectedDay = "";
  paymentSuccessful.value = false;
  paymentDone.value = false;
  paymentFailed.value = false;
  showSuccessModal.value = false;
};

// Form validation rules

// Computed properties
const availableDays = computed(() => {
  if (givingForm.recurringFrequency === "weekly") {
    return [
      { label: "Monday", value: "monday" },
      { label: "Tuesday", value: "tuesday" },
      { label: "Wednesday", value: "wednesday" },
      { label: "Thursday", value: "thursday" },
      { label: "Friday", value: "friday" },
      { label: "Saturday", value: "saturday" },
      { label: "Sunday", value: "sunday" },
    ];
  } else if (givingForm.recurringFrequency === "monthly") {
    return Array.from({ length: 28 }, (_, i) => ({
      label: `${i + 1}${getOrdinalSuffix(i + 1)}`,
      value: i + 1,
    }));
  } else if (givingForm.recurringFrequency === "yearly") {
    return [
      { label: "January 1st", value: "jan-1" },
      { label: "February 1st", value: "feb-1" },
      { label: "March 1st", value: "mar-1" },
      { label: "April 1st", value: "apr-1" },
      { label: "May 1st", value: "may-1" },
      { label: "June 1st", value: "jun-1" },
      { label: "July 1st", value: "jul-1" },
      { label: "August 1st", value: "aug-1" },
      { label: "September 1st", value: "sep-1" },
      { label: "October 1st", value: "oct-1" },
      { label: "November 1st", value: "nov-1" },
      { label: "December 1st", value: "dec-1" },
    ];
  }
  return [];
});

const setDays = (day) => {
  if (givingForm.recurringFrequency === "weekly") {
    givingForm.selectedDay = day.value;
  } else if (givingForm.recurringFrequency === "monthly") {
    givingForm.selectedDay = day.value;
  } else if (givingForm.recurringFrequency === "yearly") {
    givingForm.selectedDay = day.value;
  }
};
const computeAmount = computed(() => {
  return givingForm.amount;
});
const setTransactionReference = (payload) => {
  donationObject.value.transactionReference = payload;
};
const setPaystackAmount = () => {
  delete donationObject.value[amount];
  donationObject.value.amount = computeAmount.value * 100;
};
const resetCallPayment = (payload) => {
  callPayment.value = payload;
};

const getOrdinalSuffix = (num) => {
  const j = num % 10;
  const k = num % 100;
  if (j === 1 && k !== 11) return "st";
  if (j === 2 && k !== 12) return "nd";
  if (j === 3 && k !== 13) return "rd";
  return "th";
};
const formRules = reactive({
  purposeId: [
    {
      required: true,
      message: "Please select a giving purpose",
      trigger: "change",
    },
  ],
  amount: [
    { required: true, message: "Please enter an amount", trigger: "blur" },
    {
      type: "number",
      min: 1,
      message: "Amount must be greater than 0",
      trigger: "blur",
    },
  ],
  name: [
    { required: true, message: "Please enter your name", trigger: "blur" },
  ],
  email: [
    { required: true, message: "Please enter your email", trigger: "blur" },
    { type: "email", message: "Please enter a valid email", trigger: "blur" },
  ],
});

// Computed propert
const donation = async () => {
  const loading = ElLoading.service({
    lock: true,
    text: "Please wait...",
    background: "rgba(255, 255, 255, 0.9)",
  });
  // if(selectedGateway.value === 2){
  //   donationObject.value.productPriceId =;
  // }

  if (localStorage.getItem("giverToken") === null || !signedIn.value) {
    if (name.value !== "" || phone.value !== "") {
      donationObject.value.isAnonymous = false;
      (donationObject.value.name = name.value),
        (donationObject.value.phone = phone.value),
        (donationObject.value.email = email.value);
    } else {
      donationObject.value.isAnonymous = true;
    }
  } else {
    donationObject.value.name = userData.value.name;
    donationObject.value.email = userData.value.email;
    donationObject.value.phone = userData.value.phone;
    donationObject.value.userId = userData.value.id;
    if (checked.value) {
      donationObject.value.isAnonymous = false;
    } else {
      donationObject.value.isAnonymous = false;
    }
  }

  if (formResponse.value?.isPaymentConnected) {
    donationObject.value.isPaymentConnected =
      formResponse.value?.isPaymentConnected;
    donationObject.value.paymentConnectedObject =
      formResponse.value?.paymentConnectedObject;
  }

  try {
    const { data } = await axios.post(
      "/initailizedonationpayment",
      donationObject.value
    );
    finish();
    loading.close();

    initializePaymentResponse.value = data;

    if (data.initializePaymentResponseDTO?.data?.authorization_url) {
      checkoutURL.value =
        data.initializePaymentResponseDTO?.data?.authorization_url;
      checkoutDrawer.value = true;
      paymentStatusLoading.value = true;
      checkTransactionStatus(data?.transactionReference);
    }
    if (data.status) {
      callPayment.value = true;
    } else {
      ElNotification({
        type: "error",
        message: "Could not initialise payment, please try again",
        duration: 5000,
      });
    }
  } catch (error) {
    finish();
    loading.close();
    callPayment.value = false;
    console.log(error);
  }
};
const donationObject = computed(() => {
  const matchedTenantGateway = formResponse.value?.paymentGateWayOptions.find(
    (gateway) =>
      gateway?.churchPaymentGateway?.displayName.toLowerCase() ===
      selectedGateway.value?.toLowerCase()
  );
  const matchedGateway = formResponse.value?.paymentGateWays.find(
    (gateway) =>
      gateway.paymentGateway?.name.toLowerCase() ===
      selectedGateway.value?.toLowerCase()
  );

  return {
    paymentFormId: formResponse.value.id,
    churchLogoUrl: formResponse.value.churchLogo,
    churchName: formResponse.value.churchName,
    tenantID: formResponse.value.tenantID,
    merchantID: formResponse.value.merchantId,
    orderID: formResponse.value.orderId,
    currencyID: defaultCurrency.value.id,
    amount: computeAmount.value || 0,
    contributionItems: [
      {
        contributionItemId:
          selectedContributionType.value?.financialContribution?.id,
        contributionItemName:
          selectedContributionType.value?.financialContribution?.name,
        amount: parseFloat(givingForm.amount) || 0,
        contributionCurrencyId: defaultCurrency.value.id,
      },
    ],
    contributionItem: selectedContributionType.value?.financialContribution?.id,
    isAnonymous: givingForm.isAnonymous,
    name: givingForm.isAnonymous ? "Anonymous" : givingForm.name,
    email: givingForm.isAnonymous
      ? "anonymous@churchplus.co"
      : givingForm.email,
    phone: givingForm.isAnonymous ? "" : givingForm.phone,
    frequency: givingForm.frequency,
    paymentGateway: selectedGateway.value,
    tenantPaymentGatewayOption: matchedTenantGateway || matchedGateway,
  };
});

const checkTransactionStatus = async (_ref) => {
  try {
    const response = await ConfirmPaystackTransaction(_ref);
    if (
      paystackTransactionStatusEnum[response?.status]?.toLowerCase() ===
      "success"
    ) {
      paymentStatusLoading.value = false;
      checkoutDrawer.value = false;
      paymentResponseDialog.value = true;
      paymentStatusMessage.value =
        paystackTransactionStatusEnum[response?.status];
    } else if (
      paystackTransactionStatusEnum[response?.status]?.toLowerCase() ===
      "failed"
    ) {
      paymentStatusLoading.value = false;
      checkoutDrawer.value = false;
      paymentResponseDialog.value = true;
      paymentStatusMessage.value =
        paystackTransactionStatusEnum[response?.status];
    } else if (
      paystackTransactionStatusEnum[response?.status]?.toLowerCase() ===
      "cancelled"
    ) {
      paymentStatusLoading.value = false;
      checkoutDrawer.value = false;
      paymentResponseDialog.value = true;
      paymentStatusMessage.value =
        paystackTransactionStatusEnum[response?.status];
    } else {
      setTimeout(() => {
        checkTransactionStatus(response?.transactionReference);
      }, 4000);
    }
  } catch (error) {
    paymentStatusLoading.value = false;
    console.log(error);
  }
};

// Methods
const loadFormData = async () => {
  try {
    const response = await axios.get(
      `/give?paymentFormID=${route.params.userId}`
    );
    formResponse.value = response.data;
    purposeList.value = response.data.contributionItems || [];

    // Set default purpose if available
    if (purposeList.value.length > 0) {
      givingForm.purposeId = purposeList.value[0].financialContribution.id;
      setSelectedContributionType();
    }

    localStorage.setItem("tenantId", response.data.tenantID);
    await loadCurrencies();
  } catch (error) {
    console.error("Error loading form data:", error);
    // ElNotification({
    //   title: "Error",
    //   message: "Failed to load giving form data",
    //   type: "error",
    //   duration: 4000,
    // });
  }
};

const loadCurrencies = async () => {
  try {
    const response = await axios.get("/api/LookUp/GetAllCurrencies");
    currencyList.value = response.data;

    // Get the payment form currency
    const userCurrencyObj = currencyList.value.find(
      (i) => i.id === formResponse.value.currencyId
    );

    // Check if the payment currency is supported
    const userCurrencySupported = supportedCurrencies.find(
      (i) => i.value === userCurrencyObj?.shortCode
    );
    // Display currency (for showing user’s selected one)
    defaultCurrency.value = userCurrencyObj;
    // Payment currency (fallback to USD if not supported)
    givingForm.currency = userCurrencySupported
      ? userCurrencySupported.value
      : "USD";

  } catch (error) {
    console.error("Error loading currencies:", error);
  }
};

const setSelectedCurrency = () => {
  defaultCurrency.value = currencyList.value.find(
    (i) => i.shortCode === givingForm.currency
  );
};

const setSelectedContributionType = () => {
  selectedContributionType.value = purposeList.value.find(
    (i) => i.financialContribution.id === givingForm.purposeId
  );
  console.log(
    selectedContributionType.value,
    " selectedContributionType.value"
  );
};

const formatCurrency = (amount, currency) => {
  const numAmount = parseFloat(amount) || 0;
  const currencySymbols = {
    NGN: "₦",
    USD: "$",
    EUR: "€",
    GBP: "£",
  };
  const symbol = currencySymbols[currency] || currency;
  return `${symbol}${numAmount.toFixed(2)}`;
};
const gatewaySelected = (payload) => {
  selectedGateway.value = payload;
  donation();
};

const handleGiving = async () => {
  if (!givingFormRef.value) return;

  try {
    // Validate form
    const valid = await givingFormRef.value.validate();
    if (!valid) return;

    // Validate amount
    if (!givingForm.amount || parseFloat(givingForm.amount) <= 0) {
      ElNotification({
        title: "Invalid Amount",
        message: "Please enter a valid amount greater than 0",
        type: "warning",
        duration: 3000,
      });
      return;
    }

    // Validate non-anonymous fields
    if (!givingForm.isAnonymous) {
      if (!givingForm.name || !givingForm.email) {
        ElNotification({
          title: "Missing Information",
          message: "Please fill in your name and email",
          type: "warning",
          duration: 3000,
        });
        return;
      }
    }

    isProcessing.value = true;
    showPaymentGatewayOptions.value = true;
  } finally {
    isProcessing.value = false;
  }
};

// const resetForm = () => {
//   showSuccessModal.value = false;
//   givingForm.amount = "";
//   givingForm.name = "";
//   givingForm.email = "";
//   givingForm.phone = "";
//   givingForm.isAnonymous = false;
//   givingForm.frequency = "one-time";
// };

const signOut = () => {
  localStorage.removeItem("giverToken");
  ElNotification({
    title: "Signed Out",
    message: "You have been signed out successfully",
    type: "success",
    duration: 3000,
  });
  router.push({
    name: "SignInPayment",
    params: { userId: route.params.userId },
  });
};

// Lifecycle
onMounted(() => {
  loadFormData();
});
</script>

<style scoped>
.form-area {
  background: #fff;
  border-radius: 8px;
  height: fit-content;
}
.donation-bg {
  background: #f3fcff;
  /* min-height: 100vh; */
}
.donation-bg-mobile {
  background-image: url(../../../assets/globeweb.png);
  /* min-height: 5vh; */
  max-height: 25vh;
  background-position: center;
  background-size: cover;
}
.recurring-options {
  margin-top: 1rem;
  gap: 1rem;
}
.recurring-freq-group {
  display: flex;
  /* gap: 2rem; */
  flex-wrap: wrap;
}

.recurring-freq-radio {
  font-size: 0.9rem;
}

:deep(.recurring-freq-radio .el-radio__label) {
  color: #495057;
  font-weight: 500;
}

:deep(.recurring-freq-radio .el-radio__input.is-checked .el-radio__inner) {
  background-color: #6c757d;
  border-color: #6c757d;
}

.day-selection {
  display: flex;
  align-items: center;
  gap: 1rem;
}
.logo {
  height: 40px;
  width: auto;
}

.dash-border {
  border: 1px dashed #c0c0c0;
  padding: 1rem;
  border-radius: 8px;
}
.giving-container {
  /* min-height: 100vh; */
  padding: 0;
}

.header-section {
  padding: 1rem 2rem;
}

.church-info {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 1rem;
}

.church-logo-small {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  object-fit: cover;
}
.church-logo-mobile {
  width: 66px;
  height: 66px;
  border-radius: 50%;
  object-fit: cover;
}
.church-logo {
  width: 110px;
  height: 110px;
  padding: 1rem;
  background: #ffffff;
  border-radius: 50%;
  object-fit: cover;
}

.church-details {
  display: flex;
  flex-direction: column;
  /* align-items: flex-end; */
}

.church-name {
  font-weight: 600;
  color: #111111;
  font-size: 25px;
}

.sign-out-link {
  color: #6c757d;
  text-decoration: none;
  font-size: 0.8rem;
}

.sign-out-link:hover {
  color: #495057;
  /* text-decoration: underline; */
}

.main-title {
  font-size: 2.5rem;
  font-weight: 600;
  background: linear-gradient(270deg, #0e59e4 0%, #043591 55.29%);
  background-clip: text;
  color: transparent;
  margin-bottom: 1rem;
  line-height: 1.2;
}

.subtitle {
  font-size: 16px;
  color: #111111;
  margin-bottom: 0;
  line-height: 100%;
  font-weight: 300 !important;
  vertical-align: middle;
}

.giving-form {
  /* background: white; */
  border-radius: 12px;
  /* padding: 2rem; */
  /* box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); */
}

.form-label {
  font-size: 0.9rem;
  font-weight: 600;
  color: #111111;
  /* margin-bottom: 0.5rem; */
  display: block;
}

.section-title {
  font-size: 1rem;
  font-weight: 600;
  color: #495057;
  margin-bottom: 1rem;
}

.amount-input-group {
  display: flex;
  gap: 0;
}

.currency-select {
  width: 100px;
  flex-shrink: 0;
}

.amount-input {
  flex: 1;
}

:deep(.currency-select .el-input__wrapper) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: none;
}

:deep(.amount-input .el-input__wrapper) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.anonymous-checkbox {
  font-size: 0.9rem;
}

:deep(.anonymous-checkbox .el-checkbox__label) {
  color: #495057;
  font-weight: 500;
}

.frequency-group {
  display: flex;
  gap: 2rem;
}

.frequency-radio {
  font-size: 0.9rem;
}

:deep(.frequency-radio .el-radio__label) {
  color: #000000;
  font-weight: 500;
}

.charge-info {
  font-size: 0.9rem;
  color: #000000;
  margin: 0;
}

.payment-methods {
  text-align: center;
  /* margin-top: 2rem; */
}

.payment-logos {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  /* margin-bottom: rem; */
}

.payment-logo {
  height: 18px;
  object-fit: contain;
}

.security-text {
  font-size: 0.8rem;
  color: #6c757d;
  margin: 0;
}

.security-text i {
  margin-right: 0.5rem;
  color: #28a745;
}

.footer-section {
  text-align: center;
  margin-top: 2rem;
}

.footer-divider {
  height: 1px;
  background: #0040ff;
  margin: 2rem 0 1rem;
}

.powered-by {
  font-size: 14px;
  color: #000000;
  margin: 0;
}

/* Modal Styles */
.payment-modal :deep(.el-dialog) {
  border-radius: 12px;
}

.iframe-container {
  width: 100%;
  height: 600px;
}

.payment-loading {
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.success-modal :deep(.el-dialog) {
  border-radius: 12px;
}

.success-content {
  padding: 2rem;
}

.success-icon {
  font-size: 4rem;
  color: #28a745;
}

.success-title {
  font-size: 1.8rem;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 1rem;
}

.success-message {
  font-size: 1rem;
  color: #6c757d;
  margin-bottom: 0;
}

/* Element UI Overrides */
:deep(.el-input__wrapper) {
  border-radius: 8px;
  border: 1px solid #dee2e6;
  box-shadow: none;
  padding: 12px 16px;
}

:deep(.el-input__wrapper:hover) {
  border-color: #adb5bd;
}

:deep(.el-input__wrapper.is-focus) {
  border-color: #2c5aa0;
  box-shadow: 0 0 0 2px rgba(44, 90, 160, 0.2);
}

:deep(.el-select .el-input__wrapper) {
  border-radius: 8px;
}

:deep(.el-checkbox__input.is-checked .el-checkbox__inner) {
  background-color: #2c5aa0;
  border-color: #2c5aa0;
}

:deep(.el-radio__input.is-checked .el-radio__inner) {
  background-color: #2c5aa0;
  border-color: #2c5aa0;
}

/* Bootstrap utilities */
.w-100 {
  width: 100% !important;
}

.text-center {
  text-align: center !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.mb-4 {
  margin-bottom: 1.5rem !important;
}

.mb-5 {
  margin-bottom: 3rem !important;
}

.mt-3 {
  margin-top: 1rem !important;
}

/* Responsive Design */
@media (max-width: 768px) {
  .main-title {
    font-size: 2rem;
  }

  .giving-form {
    padding: 1.5rem;
  }

  .header-section {
    padding: 1rem;
  }

  .church-info {
    justify-content: center;
  }

  .church-details {
    align-items: center;
  }

  .frequency-group {
    flex-direction: column;
    gap: 1rem;
  }
}

@media (max-width: 576px) {
  .recurring-freq-group {
    flex-direction: column;
    gap: 1rem;
  }
  .main-title {
    font-size: 1.75rem;
  }

  .giving-form {
    padding: 1rem;
  }

  /* .amount-input-group {
    flex-direction: column;
  } */

  /* .currency-select {
    width: 100%;
  } */

  :deep(.currency-select .el-input__wrapper) {
    border-radius: 8px;
    border-right: 1px solid #dee2e6;
  }

  :deep(.amount-input .el-input__wrapper) {
    border-radius: 8px;
  }
}
</style>
